import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";




const safeTrim = (v) => (typeof v === "string" ? v.trim() : v);
const toNumOrNull = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};
const uniqueStringArray = (arr) =>
  Array.isArray(arr)
    ? [...new Set(arr.map((x) => (typeof x === "string" ? x.trim() : "")).filter(Boolean))]
    : [];

/**
 * 
 * Adiciona um produto conforme o contrato do form.
 * @param {Object} formData
 * @returns {Promise<string>} id do documento criado
 */
export default async function FbAddAds(formData) {

 // 🔁 MAP: nomes alternativos do form -> nomes persistidos
  const tipo = safeTrim(formData.type ?? formData.tipo ?? "");                 // categoria
  const subtype = safeTrim(formData.subtype ?? "");                            // subcategoria
  const nameProduto = safeTrim(formData.produto ?? formData.nameProduto ?? "");    // nome do produto (venha de nameProduto)
  const category = safeTrim(formData.category ?? "");                          // especificação do produto
  const description = safeTrim(formData.description ?? "");
  const currency = safeTrim(formData.currency ?? "");
  const img = safeTrim(formData.img ?? "");
  const idSupplier = formData.idSupplier ?? null;
  const priceNum = toNumOrNull(formData.price);
  const taxa = toNumOrNull(formData.taxa);             // valor calculado (opcional)
  const imgAlt = uniqueStringArray(formData.imgAlt);
  const transportadora = uniqueStringArray(formData.transporte ?? formData.transportadora);
  const tipoArtigo = safeTrim(formData.tipoArtigo ?? "");
  const destinoVenda = safeTrim(formData.destinoVenda ?? "");
  const size = safeTrim(formData.size ?? "");
  const color = safeTrim(formData.color ?? "");
  const fornecedor = safeTrim(formData.fornecedor ?? "");  // nome da empresa (opcional)
  const ads = safeTrim(formData.ads ?? "");
  const start = safeTrim(formData.from ?? ""); // data de pedido para ser exibido
  const expired = safeTrim(formData.to ?? ""); // data que expira
  const payref = safeTrim(formData.payref ?? ""); // codigo de recibo de pagamento
  const fee = safeTrim(formData.fee ?? "");
  const status = safeTrim(formData.status ?? "Pending")
  const line="";


  // Checagens obrigatórias
  
  // ✅ Validações
  if (!idSupplier) throw new Error("Fornecedor não autenticado (idSupplier ausente).");
  if (!tipo || !subtype) throw new Error("Caminho inválido: 'type' e 'subtype' são obrigatórios.");
  if (!category) throw new Error("Campo 'category' é obrigatório.");
  if (!nameProduto) throw new Error("Campo 'produto' é obrigatório.");
  if (!img) throw new Error("Campo 'img' (imagem principal) é obrigatório.");
  if (!Number.isFinite(priceNum) || priceNum < 0) throw new Error("Preço inválido.");
  if (!Number.isFinite(payref) || payref < 0) throw new Error("codigo de referencia inválido.");
  if (!currency) throw new Error("Moeda é obrigatória.");


  // (Opcional) normalizar type/subtype para coerência de path
  const typeKey = tipo;      // ex.: type.toLowerCase()
  const subtypeKey = subtype; // ex.: subtype.toLowerCase()

  // Monta o payload limpo
  const payload = {
    fornecedor,
    nameProduto,
    description,
    price: priceNum,
    category,
    subtype: subtypeKey,
    tipo: typeKey,
    currency,
    img,
    imgAlt,
    createdAt: serverTimestamp(),
    idSupplier,
    transportadora,
    tipoArtigo,
    destinoVenda,
    taxa,
    size,
    color,
    payref,
    fee,
    start,
    expired,
    status,
    line,
  };

  try {
   const ref = collection(db, "Db/Marketing",ads);
   const docRef = await addDoc(ref, payload);
  return docRef.id;
 
    
  } catch (err) {
    // Logue o erro para observabilidade (Sentry/console)
    console.error("FbAddProductService :: addDoc error", err);
    // Propague erro para a UI tratar
    throw new Error("Falha ao salvar o produto no Firestore.");
  }
}